/**
 * Free Quota Display Utilities
 * 
 * Rules:
 * - Show indicator only when at 70%+ of limit OR within 1 of limit
 * - Use neutral, non-promotional text
 * - Never show in time-based cards
 * - Informational only - doesn't block actions
 */

// Free limits (must match backend)
// NOTE: Publishing public events is always free (no limit)
export const FREE_LIMITS = {
  private_events: 3,
  groups: 2,
  circles: 1
};

/**
 * Determines if quota indicator should be visible
 * Show when: at 70%+ of limit OR within 1 of limit
 */
export const shouldShowQuota = (current, limit) => {
  if (limit === 0 || current === null || current === undefined) return false;
  // Within 1 of limit
  if (current >= limit - 1) return true;
  // At or above 70% of limit
  if (current / limit >= 0.7) return true;
  return false;
};

/**
 * Gets the quota display text in quiet/neutral format
 * Returns null if should not display
 */
export const getQuotaText = (current, limit, options = {}) => {
  if (!shouldShowQuota(current, limit)) return null;
  
  const remaining = Math.max(0, limit - current);
  const { format = 'used' } = options; // 'used', 'left', 'status'
  
  switch (format) {
    case 'left':
      if (remaining === 0) return 'limit reached';
      return `${remaining} free left`;
    case 'status':
      if (remaining === 0) return 'Limit reached';
      return `${remaining} free remaining`;
    case 'used':
    default:
      return `${current} of ${limit} free used`;
  }
};

/**
 * Gets quota text for display next to Create buttons
 * Only shows when near/at limit
 */
export const getCreateButtonQuota = (current, limit) => {
  if (!shouldShowQuota(current, limit)) return null;
  
  const remaining = Math.max(0, limit - current);
  if (remaining === 0) return '(limit reached)';
  return `(${remaining} free left)`;
};
